//@ts-check
import request from '../request';
import saveFile from '../saveFile';
/**
 * Export contacts from a list by specifying which fields to include
 * @param {number} id List id
 * @param {string[]} fields Fields to export
 * @param {import('../types').ExportFileFormat} format Exported file format
 * @param {string} filename Exported file name
 * @return {Promise<any>}
 */

var exportList = function exportList(id, fields, format, filename) {
  return request({
    url: '/backend/contacts/export',
    method: 'POST',
    data: {
      Format: format || 'CSV',
      ListId: id,
      Fields: fields
    }
  }).then(function (response) {
    return saveFile(response, format, filename);
  });
};
/**
 * @param {string} path Path to the csv file being imported
 * @param {string} workspace Path's workspace
 * @returns {Promise<import('./types').ContactImportProgress>}
 */


var getImportListStatistics = function getImportListStatistics(path, workspace) {
  return request({
    url: '/backend/contacts/import',
    query: {
      workspace: workspace,
      path: path
    }
  });
};
/**
 * @param {string} path Path to a csv file in repository
 * @param {string} workspace Path's workspace
 * @param {import('./types').ContactImportOptions} options
 * @param {import('./types').ContactImportProgressCallback} progress
 */


var importListFromCsv = function importListFromCsv(path, workspace, options, progress) {
  var reportProgress = function reportProgress() {
    return getImportListStatistics(path, workspace).then(function (stats) {
      stats.TotalSkipped = stats.DuplicateSkipped + stats.EmptySkipped;
      stats.TotalProcessed = stats.Succeeded + stats.Failed + stats.TotalSkipped;
      stats.Progress = Math.floor(100 * stats.TotalProcessed / stats.Count);
      if (progress) progress(stats);
      return stats;
    });
  };

  var promise = new Promise(function (resolve, reject) {
    setTimeout(function run() {
      reportProgress().then(function (stats) {
        var finished = stats.Progress === 100;
        if (finished) return resolve();
        setTimeout(run, 1000);
      });
    }, 10);
    request({
      url: '/backend/contacts/import',
      method: 'POST',
      query: {
        workspace: workspace,
        path: path
      },
      data: options
    }).then(function () {}).catch(function (err) {
      reject(err);
    });
  });
  return promise;
};
/**
 * @param {File} file
 * @returns {import('./types').ContactImportSchema}
 */


var uploadCsvToImport = function uploadCsvToImport(file) {
  return request({
    url: '/backend/contacts/import/file',
    method: 'POST',
    auth: 'field',
    fields: [{
      name: 'file',
      value: file
    }]
  });
};
/**
 * @param {number} eosContactId
 * @returns {import('./types').ListSubscriptionModel[]}
 */


var getContactLists = function getContactLists(eosContactId) {
  return request({
    url: "/backend/contacts/".concat(eosContactId, "/lists")
  });
};

export default {
  exportList: exportList,
  uploadCsvToImport: uploadCsvToImport,
  importListFromCsv: importListFromCsv,
  getContactLists: getContactLists
};